/**
 * Checks if a failed request was stopped by the AWS WAF CAPTCHA rule.
 * For non-HTML requests (e.g. fetch POSTs) WAF responds with HTTP 405 and an x-amzn-waf-action: captcha header.
 * @param error The error returned by the tRPC client.
 * @returns true if the user has to solve a CAPTCHA puzzle before retrying, false otherwise.
 */
export function isWafCaptchaChallenge(error: unknown): boolean {
  const response = (error as { meta?: { response?: Response } } | null)?.meta?.response;
  return response?.status === 405 && response.headers.get('x-amzn-waf-action') === 'captcha';
}
